import React from "react";
import { usePermissions } from "./PermissionContext";
import { hasPermission } from "../store/slices/roleSlice";
import { useSelector } from "react-redux";

export default function Can({ permission, children }) {
  const user = useSelector(state => state.auth?.after_login_data?.data);
  return hasPermission(user, permission) ? children : null;
}
